import React, { useState, useEffect } from "react";
import CanvasResizerMenu from './CanvasResizerMenu';
import './canvasResizer.scss';

export default function CanvasResizer() {
    const [isCanvasResizerActive, setIsCanvasResizerActive] = useState(false);

    const handleShowCanvasResizerMenu = () => {
        setIsCanvasResizerActive(!isCanvasResizerActive);
    }

    return (
        <>
            {isCanvasResizerActive &&
                <CanvasResizerMenu canvasResizerMenuToggle={handleShowCanvasResizerMenu} />
            }
            <section className="canvas-resizer-section" onClick={handleShowCanvasResizerMenu}>
                <button className={`${isCanvasResizerActive ? 'canvas-resizer-button canvas-resizer-button_active' : 'canvas-resizer-button'}`}>
                    <span className="canvas-resizer-paragraph">Resize</span>
                </button>
            </section>
        </>
    )
}